import React, { useContext } from "react";
import { FaWarehouse, FaBoxOpen, FaPallet, FaFireExtinguisher } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./ware.jpg";

const Warehouse: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/warehouse-safety');
    } else {
      navigate('/login', { state: { from: '/booking/warehouse-safety' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Logistics</span>
          <h1 className="hero-title">Warehouse Safety</h1>
          <p className="hero-subtitle">
            Managing efficiency and safety in high-traffic zones. Racking standards,
            traffic management, and pedestrian safety.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Traffic Management</h2>
              <p className="article-text">
                Warehouses are busy intersections of people and heavy machinery.
                <br />- Segregate pedestrian walkways with barriers.
                <br />- Install blind-spot mirrors at corners.
                <br />- Enforce speed limits for forklifts.
                <br />- Wear High-Visibility vests at all times.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Racking Safety</h2>
              <p className="article-text">
                Racks carry tons of weight. Never climb racks. Report bent uprights immediately—a damaged leg
                reduces capacity drastically. Ensure Safe Working Load (SWL) signs are visible.
                Heavier pallets go on the bottom; lighter ones on top.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Manual Handling & Ergonomics</h2>
              <p className="article-text">
                Picker/Packer injuries are common. Use team lifts for heavy items ({'>'}25kg).
                Rotate tasks to prevent Repetitive Strain Injury (RSI). Keep the "Golden Zone"
                (waist to shoulder) for frequently picked items to minimize bending.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Housekeeping (5S)</h2>
              <p className="article-text">
                Slips, trips, and falls are the #1 cause of injury. Keep aisles specific, clear, and clean.
                Remove shrink wrap debris immediately. A clean warehouse is a safe warehouse.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Warehouse Rules</h4>
              <ul className="key-list">
                <li><FaWarehouse className="check-icon" /> Pedestrians Give Way</li>
                <li><FaBoxOpen className="check-icon" /> Secure Loose Loads</li>
                <li><FaPallet className="check-icon" /> Check Pallet Integrity</li>
                <li><FaFireExtinguisher className="check-icon" /> Keep Exits Clear</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Organize & Safe</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                A safe warehouse is an efficient warehouse.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Warehouse;
